import { Companion_getInstance2lw3j8toa9ha6 as Companion_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import {
  toNotBlankString1ovj48s0kinvm as toNotBlankString,
  NotBlankString__toString_impl_5tex9r22pq2l6hpj9hd as NotBlankString__toString_impl_5tex9r,
  NotBlankString__hashCode_impl_fxqzj43axmbww1ctojf as NotBlankString__hashCode_impl_fxqzj4,
} from '../../../../../../types-types/kotools/types/text/NotBlankString.mjs';
import {
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqgfu6uyyvgx74d as _Result___get_value__impl__bjfvqg,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      w29() {
        // Inline function 'kotlin.getOrThrow' call
        var this_0 = toNotBlankString(Companion_getInstance().rt().toString());
        throwOnFailure(this_0);
        var tmp$ret$0 = _Result___get_value__impl__bjfvqg(this_0).v28_1;
        return new (PairingSetId())(tmp$ret$0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
var PairingSetIdClass;
function PairingSetId() {
  if (PairingSetIdClass === VOID) {
    class $ {
      constructor(value) {
        this.l2c_1 = value;
      }
      toString() {
        return 'PairingSetId(value=' + NotBlankString__toString_impl_5tex9r(this.l2c_1) + ')';
      }
      hashCode() {
        return NotBlankString__hashCode_impl_fxqzj4(this.l2c_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PairingSetId()))
          return false;
        if (!(this.l2c_1 === other.l2c_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PairingSetId');
    PairingSetIdClass = $;
  }
  return PairingSetIdClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  PairingSetId as PairingSetId2cohvchymqgsy,
  Companion_instance as Companion_instancele9kk9oqjejr,
};
//endregion

//# sourceMappingURL=PairingSetId.mjs.map
